import React, { useState } from "react";
import "./ChatBot.css";

const ChatBot = () => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const faqData = [
    {
      question: "كيف يمكنني التسجيل في منصة علمني؟",
      answer: "يمكنك التسجيل بسهولة من خلال النقر على زر 'تسجيل الدخول' في الناف بار، ثم اختيار 'إنشاء حساب جديد' وملء البيانات المطلوبة."
    },
    {
      question: "ما هي المختبرات التفاعلية المتاحة؟",
      answer: "نوفر مختبرات تفاعلية في الفيزياء والكيمياء والرياضيات. يمكنك الوصول إليها من خلال 'معامل علمني' في الناف بار، مثل مختبر قوة التجاذب."
    },
    {
      question: "كيف يمكنني تغيير كلمة المرور؟",
      answer: "يمكنك تغيير كلمة المرور من خلال الذهاب إلى إعدادات الحساب، أو استخدام خيار 'نسيت كلمة المرور' إذا لم تتذكر كلمة المرور الحالية."
    },
    {
      question: "هل المحتوى مجاني؟",
      answer: "نعم، معظم المحتوى التعليمي والمختبرات التفاعلية مجانية. بعض الدورات المتقدمة قد تتطلب اشتراك مدفوع."
    },
    {
      question: "كيف يمكنني التواصل مع الدعم الفني؟",
      answer: "يمكنك التواصل معنا من خلال صفحة 'تواصل معنا' أو إرسال رسالة مباشرة عبر هذا الشات بوت. فريق الدعم متاح على مدار الساعة."
    },
    {
      question: "ما هي المواد الدراسية المتاحة؟",
      answer: "نغطي جميع المواد الأساسية: الرياضيات، الفيزياء، الكيمياء، الأحياء، اللغة العربية، اللغة الإنجليزية، والعلوم الاجتماعية."
    },
    {
      question: "كيف يمكنني الوصول للمحتوى من الموبايل؟",
      answer: "المنصة متوافقة تماماً مع جميع الأجهزة المحمولة. يمكنك الوصول للمحتوى من خلال أي متصفح على هاتفك أو تابلت."
    },
    {
      question: "هل يمكنني تحميل المحتوى للاستخدام دون اتصال؟",
      answer: "نعم، يمكنك تحميل بعض المحتويات للاستخدام دون اتصال بالإنترنت. ابحث عن أيقونة التحميل بجانب المحتوى المطلوب."
    }
  ];

  return (
    <div className="chatbot-fixed">
      {!open && (
        <button className="chatbot-icon" onClick={() => setOpen(true)} title="اسألنا">
          💬
        </button>
      )}
      {open && (
        <div className="chatbot-window" style={{ direction: "rtl" }}>
          <div className="chatbot-header">
            <span style={{ textAlign: "right" }}>مساعد علمني</span>
            <button className="chatbot-close" onClick={() => { setOpen(false); setSelected(null); }}>×</button>
          </div>
          <div className="chatbot-body">
            {!selected ? (
              <>
                <div className="chatbot-welcome">
                  <h4>مرحباً بك في منصة علمني! 👋</h4>
                  <p>كيف يمكنني مساعدتك اليوم؟</p>
                </div>
                <ul className="chatbot-faq-list">
                  {faqData.map((item, idx) => (
                    <li key={idx}>
                      <button 
                        className="chatbot-question" 
                        onClick={() => setSelected(item)}
                        style={{ textAlign: "right" }}
                      >
                        {item.question}
                      </button>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <div className="chatbot-answer-block" style={{ alignItems: "flex-end" }}>
                <div className="chatbot-question-selected" style={{ textAlign: "right", width: "100%" }}>
                  {selected.question}
                </div>
                <div className="chatbot-answer" style={{ textAlign: "right", width: "100%" }}>
                  {selected.answer}
                </div>
                <button 
                  className="chatbot-back" 
                  onClick={() => setSelected(null)}
                  style={{ alignSelf: "flex-start" }}
                >
                  العودة للأسئلة
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot; 